import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { RegistrationVerifyListComponent } from './components/registration-verify-list/registration-verify-list.component';
import { RegistrationVerifyComponent } from './components/registration-verify/registration-verify.component';
import { RegistrationVerifyDetailsComponent } from './components/registration-verify-details/registration-verify-details.component';
import { RegistrationVerifySearchComponent } from './components/registration-verify-search/registration-verify-search.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { DatePipe } from '@angular/common'
import { NgxPaginationModule } from 'ngx-pagination';
import { ContactListComponent } from './components/contact-list/contact-listcomponent';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
@NgModule({
  declarations: [
    AppComponent,
    RegistrationVerifyListComponent,
    ContactListComponent,
    RegistrationVerifyComponent,
    RegistrationVerifyDetailsComponent,
    RegistrationVerifySearchComponent,
    NavbarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    NgxPaginationModule
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
